module.exports = __webpack_public_path__ + "static/media/VU.7713db5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/VU.svg
// module id = 2290
// module chunks = 7